import React from 'react';
import { Button } from 'react-bootstrap';
import { getProgramChipStyle, getRpmEligibleChipStyle, getProgramTypeCount } from '../../utils/programChipHelpers';

const programOptions = [
    { id: '', name: 'All' },
    { id: 'ccm', name: 'CCM' },
    { id: 'apcm', name: 'APCM' },
];

const legendItems = [
    {
        label: 'CCM',
        description: 'Chronic Care Management',
        chipStyle: getProgramChipStyle('CCM'),
    },
    {
        label: 'APCM',
        description: 'Advanced Primary Care',
        chipStyle: getProgramChipStyle('APCM'),
    },
    {
        label: '+ RPM',
        description: 'Remote Patient Monitoring (add-on)',
        chipStyle: getRpmEligibleChipStyle(),
    },
];

const RpmUnverifiedQueueHeader = ({
    label,
    totalCount,
    subtitle,
    programType,
    programTypeCounts,
    onProgramTypeChange,
    onRefresh,
}) => {
    const allCount = getProgramTypeCount(programTypeCounts, '') ?? totalCount;

    const getToggleLabel = (id, name) => {
        const count = getProgramTypeCount(programTypeCounts, id);
        if (count != null && count >= 0) {
            return `${name} (${count})`;
        }
        return name;
    };

    return (
        <div className="rpm-unverified-queue-header">
            <div className="rpm-unverified-queue-header__row">
                <div className="rpm-unverified-queue-header__title">
                    <span className="rpm-unverified-queue-header__label">
                        {label} — {allCount}
                    </span>
                    {subtitle &&
                        <span className="rpm-unverified-queue-header__subtitle">{subtitle}</span>
                    }
                </div>
                <div className="rpm-unverified-queue-header__refresh">
                    <span className="rpm-unverified-queue-header__refresh-label">Queue</span>
                    <Button
                        bsSize="xsmall"
                        bsStyle="primary"
                        style={{ marginLeft: 15 }}
                        onClick={onRefresh}
                    >
                        <i className="fa fa-refresh" title="Queue refresh" />
                    </Button>
                </div>
            </div>
            <div className="rpm-unverified-queue-header__row rpm-unverified-queue-header__row--secondary">
                <div className="rpm-unverified-queue-header__toggles">
                    <span className="rpm-unverified-queue-header__toggles-label">Main program:</span>
                    <div className="btn-group">
                        {programOptions.map(({ id, name }) => {
                            const isActive = programType === id || (!programType && !id);
                            return (
                                <Button
                                    key={id || 'all'}
                                    bsSize="small"
                                    bsStyle={isActive ? 'primary' : 'default'}
                                    onClick={() => onProgramTypeChange(id)}
                                >
                                    {getToggleLabel(id, name)}
                                </Button>
                            );
                        })}
                    </div>
                </div>
                <div className="rpm-unverified-queue-header__legend">
                    {legendItems.map(({ label: chipLabel, description, chipStyle }) =>
                        <div key={chipLabel} className="rpm-unverified-queue-header__legend-item">
                            <span style={chipStyle}>{chipLabel}</span>
                            <span>{description}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RpmUnverifiedQueueHeader;
